module.exports = __webpack_public_path__ + "img/kanae_midsummer.07d0d1f4.png";